import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { ArrowRight2 } from "iconsax-react";
import {
  Box,
  Center,
  Divider,
  Flex,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { subcategories } from "../../../utils/SubCategorys";

export default function CarouselSubcategory() {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { subcategory = "" } = useParams<{ subcategory?: string }>();

  const isLargerThan991 = useMediaQuery("(min-width: 991px)");

  const handleClick = (subcategory: string) => {
    if (!subcategory || subcategory === "all") {
      navigate("/marketplace");
    } else {
      navigate(`/marketplace/${subcategory}`);
    }
  };

  return (
    <Box
      p={{ base: 0, 991: 24 }}
      mb={{ base: 30, 991: 48 }}
      bg={theme.colors.basic[0]}
      h={{ base: 120, 991: 176 }}
      sx={{
        borderRadius: "12px",
        boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.05)",
      }}
    >
      <Flex
        direction={{ base: "column", 991: "row" }}
        sx={{
          border: "1px solid",
          borderColor: theme.colors.basic[1],
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <Flex
          align="center"
          ml={{ base: 12, 991: 0 }}
          justify={{ base: "start", 991: "space-around" }}
          bg="basic.0"
          miw={257}
          h={{ base: 44, 991: 128 }}
        >
          <Flex
            align={{ base: "start" }}
            direction={{ base: "row", 991: "column" }}
          >
            <Text color="basic.4" fz={{ base: 14, 991: 16 }} pr={12}>
              {t("global.carrousel_subcategory.title")}
              {!isLargerThan991 ? " : " : null}
            </Text>
            <Text color="basic.5" fz={{ base: 16, 991: 24 }} weight={700}>
              {t("global.carrousel_subcategory.subcategory")}
            </Text>
          </Flex>
          {isLargerThan991 ? (
            <Center>
              <ArrowRight2
                size="32"
                color={theme.colors.basic[5]}
                variant="Outline"
              />
            </Center>
          ) : null}
        </Flex>
        <Divider
          w={{ base: "100%", 991: "auto" }}
          orientation={isLargerThan991 ? "vertical" : "horizontal"}
          size={1}
          color={theme.colors.basic[1]}
        />

        <Swiper
          style={{
            margin: 0,
          }}
          centeredSlides={false}
          slidesPerView={"auto"}
          spaceBetween={0}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          {subcategories?.map((item, index: number) => (
            <SwiperSlide
              key={index}
              style={{
                width: "fit-content",
                display: isLargerThan991 ? "unset" : "flex",
                alignItems: isLargerThan991 ? "unset" : "center",
                justifyContent: isLargerThan991 ? "unset" : "center",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
              onClick={() => {
                handleClick(item.value);
              }}
            >
              <Center
                py={10}
                my={{ base: 14, 991: 24 }}
                h={{ base: 48, 991: 80 }}
                w={{ base: "fit-content", 991: "216px" }}
                sx={{
                  cursor: "pointer",
                  borderRadius: "12px",
                  border:
                    item.value === subcategory
                      ? `1.5px solid ${theme.colors.primary[1]}`
                      : isLargerThan991
                      ? "1px solid transparent"
                      : `1px solid ${theme.colors.basic[2]}`,
                  transition: "0.3s",
                }}
              >
                <Text
                  color={theme.colors.primary[0]}
                  fz={{ base: "12px", 991: "24px" }}
                  p={{ base: "5px", 991: "5px 50px" }}
                  fw={600}
                  style={{ whiteSpace: "nowrap" }}
                >
                  {t(item.name)}
                </Text>
              </Center>
            </SwiperSlide>
          ))}
        </Swiper>
      </Flex>
    </Box>
  );
}
